import PurchaseBusinessService from '../../purchase-business-service';
import Pagination from '@/components/pagination/index.vue';
import { changeSkin } from '@/utils/common.js';
export default {
  components: {
    Pagination
  },
  data () {
    return {
      currentProjectId: '',
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableList: []
    };
  },
  created () {
    this.getPurchaseFileList();
  },
  computed: {
  },
  methods: {
    changeSkin,
    // 获取发布项目列表
    getPurchaseFileList (page) {
      if (page) {
        this.currentPage = page.pageNo;
        this.pageSize = page.pageSize;
      }
      PurchaseBusinessService.getPurchaseFileList({
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.tableList = res.data.list;
        }
      });
    },
    goToDetail (item) {
      window.open(window.location.origin + '/#/collective-purchasing/detail?id=' + item.id);
    },
    // 下载采购文件
    downLoadFile (item) {
      if (item.urls && item.urls[0]) {
        window.open(item.urls[0].allPath);
      }
    },
    // 下载响应文件模版
    downLoadFileTemplate (item) {
      if (item.responseFileUrl) {
        window.open(item.responseFileUrl);
      }
      // if (item.purchaseResponseFileUrl) {
      //   let link = document.createElement('a');
      //   link.style.display = 'none';
      //   link.href = 'data:file/doc;base64,' + item.purchaseResponseFileUrl;
      //   link.download = '响应文档模版.doc';
      //   document.body.appendChild(link);
      //   link.click();
      //   window.URL.revokeObjectURL(link.href);
      // }
    },
    // 跳转到报名页面
    toTransactionProSignup (item) {
      this.$router.push(`/collective-purchasing/sign-up?id=${item.id}&purchaseType=${item.purchaseType}&promiseEnterprise=${item.promiseEnterprise}&criminalRecord=${item.promiseEnterprise}&qualificationReview=${item.qualificationReview}`);
    }
  }
};
